__turbopack_context__.v({
  "board": "LeaderboardBoard-module-scss-module__Ou9x1q__board",
  "gap": "LeaderboardBoard-module-scss-module__Ou9x1q__gap",
  "gapButton": "LeaderboardBoard-module-scss-module__Ou9x1q__gapButton",
  "gapDots": "LeaderboardBoard-module-scss-module__Ou9x1q__gapDots",
  "header": "LeaderboardBoard-module-scss-module__Ou9x1q__header",
  "item": "LeaderboardBoard-module-scss-module__Ou9x1q__item",
  "list": "LeaderboardBoard-module-scss-module__Ou9x1q__list",
  "loadMore": "LeaderboardBoard-module-scss-module__Ou9x1q__loadMore",
  "loadMoreButton": "LeaderboardBoard-module-scss-module__Ou9x1q__loadMoreButton",
  "loading": "LeaderboardBoard-module-scss-module__Ou9x1q__loading",
  "selfLabel": "LeaderboardBoard-module-scss-module__Ou9x1q__selfLabel",
  "selfSection": "LeaderboardBoard-module-scss-module__Ou9x1q__selfSection",
  "selfSticky": "LeaderboardBoard-module-scss-module__Ou9x1q__selfSticky",
});
